import Title from "../Title";
import { createContext, useContext, useEffect, useState } from "react";
import Frame420 from "./Frame20";
import { leftBoxContext } from "../Frameleft.js";
import { addAddress, getAddress } from "../../../../network/api/user.js";
import LocationCardCheckout from "../../LocationCardCheckout.js";
import { useLocation, useNavigate } from "react-router-dom";
import * as main_category from "../../../../network/api/maincategory.js";
import Image from "../../assets/add.png";
import { useTranslation } from "react-i18next";
import { useAddress } from "../../AddressContext.jsx";

export const CheckoutContext = createContext();
function Frame421(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [AddressType, setAddressType] = useState("home");
  const [success, setSuccess] = useState("");
  const [fail, setFail] = useState("");
  const [getLat, setgetLat] = useState(0);
  const [getLng, setgetLng] = useState(0);
  const [error, setError] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");
  const [getAddresses, setgetAddresses] = useState([]);
  const { selectedAddress, handleAddressSelect } = useContext(leftBoxContext);

  useEffect(() => {
    if (status === "Success") {
      setSuccess("payment is done succefully! ");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } else if (status === "Faild") {
      setFail("payment is fail! ");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
  }, [navigate, status]);

  useEffect(() => {
    getAddress().then((response) => {
      setgetAddresses(response.data.addresses);
    });
  }, []);
  const {  setSelectedAddress } = useAddress();

  const { name, phone, city, area, address, house } =
    useContext(leftBoxContext);
  const statePaymentHandler = async (e) => {
    e.preventDefault();
    setSelectedAddress({ name, phone, city, area, address, house });

    const namePattern = /^[A-Za-z\s]+$/;
    const Phone_REGEX = /^\d*$/; //reg for name which contain numbers
    const ANY_Name_REGEX = /^.*$/;
    if (props.cartItems.length === 0) {
      setError("no products on cart");
      setTimeout(() => {
        setError("");
      }, 2000);
      return;
    }
    if (selectedAddress === "addNewAddress") {
      if (name === "") {
        setError("fullName is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (!namePattern.test(name)) {
        setError("Invalid name. Please use only letters and spaces.");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (!Phone_REGEX.test(phone)) {
        setError("Invalid phone number. Please use only numbers.");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }

      if (phone === "") {
        setError("Phone is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }

      if (city === "") {
        setError("City is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }

      if (area === "") {
        setError("Area is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (!ANY_Name_REGEX.test(area)) {
        setError("Invalid area. Please use only strings.");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }

      if (address === "") {
        setError("Address is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (!ANY_Name_REGEX.test(address)) {
        setError("Invalid address. Please use only strings.");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }

      if (house === "") {
        setError("House is required");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (!ANY_Name_REGEX.test(house)) {
        setError("Invalid house. Please use only strings.");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      const formData = {
        fullName: name,
        mobileNumber: phone,
        city,
        area,
        address,
        house,
      };
      await addAddress(formData)
        .then(() => {
          props.setCheckoutPayment(true);
        })
        .catch((err) => {
          setError(err.message);
        });
    } else if (
      selectedAddress !== null &&
      typeof selectedAddress === "object"
    ) {
      props.setCheckoutPayment(true);
    } else {
      setError("you should select an address");
      setTimeout(() => {
        setError("");
      }, 2000);
    }
  };

  return (
    <div className="frame-421 mt-0 ">
      {status === "Success" && (
        <div class="alert alert-success" role="alert">
          {success}
        </div>
      )}
      {status === "Faild" && (
        <div class="alert alert-danger" role="alert">
          {fail}
        </div>
      )}
      {!status && (
        <CheckoutContext.Provider
          value={{
            AddressType,
            setAddressType,
            getLat,
            setgetLat,
            getLng,
            setgetLng,
          }}
        >
          <h6 className=" fs-5 mb-2  ">{t("chooseAddress")}</h6>
          <form action="" method="" onSubmit={statePaymentHandler}>
            {selectedAddress === "addNewAddress" && (
              <p style={{ color: "#a5a5a5", marginBottom: "20px" }}>
                {t("addressDesc")}
              </p>
            )}
            {selectedAddress !== "addNewAddress" && (
              <>
                {getAddresses.map((address) => (
                  <LocationCardCheckout
                    key={address.id}
                    address={address}
                    selected={address === selectedAddress}
                    onSelect={handleAddressSelect}
                  />
                ))}
                <div
                  className="my-3 d-flex gap-2"
                  onClick={() => handleAddressSelect("addNewAddress")}
                >
                  <img src={Image} alt="add" width={24} height={24} />
                  <span className=" fw-bold" style={{ cursor: "pointer" }}>
                    {t("addAddress")}
                  </span>
                </div>
              </>
            )}
            {/* Add a radio button for adding a new address */}
            {selectedAddress === "addNewAddress" && <Frame420 />}

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <button className="submit">{t("securePay")}</button>
          </form>
        </CheckoutContext.Provider>
      )}
    </div>
  );
}

export default Frame421;
